/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ex_NoteInputs */

const en_csv_to_json_ex_note = /** @type {(inputs: Csv_To_Json_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The zip code kept its leading zero because it stayed a string. Had the parser guessed types, 07030 would have become 7030 and the value would be wrong for every downstream consumer.`)
};

const ko_csv_to_json_ex_note = /** @type {(inputs: Csv_To_Json_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우편번호가 문자열로 남았기 때문에 앞의 0을 유지했습니다. 파서가 타입을 추측했다면 07030은 7030이 되어 이후 모든 소비자에게 잘못된 값이 되었을 것입니다.`)
};

const ja_csv_to_json_ex_note = /** @type {(inputs: Csv_To_Json_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`郵便番号は文字列のままだったので先頭のゼロを保ちました。パーサが型を推測していたら 07030 は 7030 になり、下流のすべての利用者にとって誤った値になっていました。`)
};

/**
* | output |
* | --- |
* | "The zip code kept its leading zero because it stayed a string. Had the parser guessed types, 07030 would have become 7030 and the value would be wrong for ev..." |
*
* @param {Csv_To_Json_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ex_note = /** @type {((inputs?: Csv_To_Json_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ex_note(inputs)
	if (locale === "ko") return ko_csv_to_json_ex_note(inputs)
	return ja_csv_to_json_ex_note(inputs)
});